export default __webpack_public_path__ + "bullets.778803fd4cfeeb4c.svg";